import PreviewMediaUrls from "components/brandHeader/PreviewMediaUrls";
import { TranslationText } from "components/TextTranslationContainer";
import { useLang } from "hooks";
import { t } from "i18next";
import AED from "icons/AED";
import React, { useMemo } from "react";

const RenderServices = ({ stores }) => {
  
    const activeServices = useMemo(() => {
        if (!stores?.length) return {
          isDeliveryEnabled: false,
          isPickupEnabled: false,
          isDineInEnabled: false,
          isFreeDeliveryEnabled: false,
        };
      
        return {
          isDeliveryEnabled: stores.some(s => s?.isDeliveryEnabled),
          isPickupEnabled: stores.some(s => s?.isPickupEnabled),
          isDineInEnabled: stores.some(s => s?.isDineInEnabled),
          isFreeDeliveryEnabled: stores.some((s) => Boolean(
            s?.deliveryChargesWaiverInfo?.onOrderAmount?.isEnabled ||
            s?.deliveryChargesWaiverInfo?.onDateRange?.isEnabled
          )),
        };
      }, [stores]);
      

  const services = {
    isDeliveryEnabled: {
      name: t("Delivery"),
      symbol: "🚚",
    },
    isPickupEnabled: {
      name: t("Pickup"),
      symbol: "🛍️",
    },
    isDineInEnabled: {
      name: t("Dine In"),
      symbol: "🍽️",
    },
    isFreeDeliveryEnabled: {
      name: t("Free Delivery"),
      symbol: "🚚",
    },
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {Object.keys(services).map((key, index) => {
        return (
          <div className="flex items-center gap-2" key={`service-${key}-${index}`}>
            {activeServices?.[key] && (
              <div className="flex items-center gap-2 border px-2 py-1 rounded-16x">
                {services[key]?.symbol}
                <span className="text-14x font-semibold">
                  {services[key]?.name}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const RenderDiscounts = ({ discounts }) => {
  if (discounts?.length <= 0) return null;
  return (
    <div className="flex items-center flex-wrap gap-2">
      {discounts
        ?.sort((a, b) => b?.discountAmount - a?.discountAmount)
        ?.slice(0, 2)
        ?.map((discount, index) => (
          <div
            key={`discount-${discount?._id || index}-${index}`}
            className="text-14x font-semibold border px-2 py-1 rounded-16x flex items-center gap-1"
          >
            🎁
            <span>{discount?.discountAmount}</span>
            {discount?.discountType?.toLowerCase() === "percentage" ? (
              "%"
            ) : (
              <AED width={14} height={14} />
            )}
          </div>
        ))}
    </div>
  );
};

const BrandCard = ({ brand, showFullCardImage = false, index }) => {
  const { isArabic } = useLang();
  const getMediaSource = () => {
    if (brand?.setting?.showBannerVideo) {
      return brand?.setting?.brandVideoHomeBG;
    }
    return brand?.setting?.brandImageHomeBG;
  };
  const handleOrderNow = (domainName) => {
    const url = window.location.origin + "/" + domainName;
    window.open(url, "_blank");
    // window.location.replace(url)
  }
  return (
    <div className="border border-gray-200 flex flex-col shadow-md rounded-16x overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300 relative">
      <PreviewMediaUrls
        sourceUrl={getMediaSource()}
        showVideoAmbientEffect={false}
        showImageAmbientEffect={true}
        videoProps={{}}
        imageProps={{}}
        containerStyleProps={{
          style: {
            width: "100%",
            height: showFullCardImage ? "300px" : "150px",
          },
        }}
      />
      <div
        className={`p-4   flex justify-between items-end gap-2 ${
          showFullCardImage
            ? "absolute bottom-0 left-0 right-0 bg-black/10 backdrop-blur-lg text-white"
            : ""
        }`}
        style={{
          zIndex: 5,
        }}
      >
        <div className="flex-1 flex flex-col gap-2">
          <h3
            className={`text-18x font-semibold ${
              showFullCardImage ? "text-white" : "text-shadow-forge-900"
            }`}
          >
            {brand?.brandName || "Brand Name"}
            {/* {index+1} */}
          </h3>
          <p
            className={`text-14x ${
              showFullCardImage ? "text-white" : "text-shadow-forge-600"
            }`}
          >
            {(brand?.baseLanguage?.toLowerCase() === "en" || !isArabic
              ? brand?.setting?.taglineEN
              : brand?.setting?.taglineAR) || "Brand description goes here"}
          </p>
          <RenderServices stores={brand?.stores} />
          <RenderDiscounts discounts={brand?.discounts} />
        </div>
        <button
          type="button"
          className="rounded-24x bg-gradient-to-r from-red-700 to-yellow-400 
                 hover:bg-gradient-to-l hover:from-red-700 hover:to-yellow-400 
                focus:outline-none font-medium 
                 text-sm text-center p-1"
          style={{
            width: "100px",
            height: "30px",
          }}
          onClick={() => handleOrderNow(brand?.setting?.temporaryDomainName)}
        >
          <TranslationText text={t("Order Now") + "!"} className="text-white" />
        </button>
      </div>
    </div>
  );
};

export default BrandCard;
